export default "<p>\r\n  score-sheet-page works!\r\n</p>\r\n";